import {
  Definition,
  DefinitionList,
  Section,
  SectionHeader,
} from '@apexinternal/ui-components'
import { BoxProps } from '@chakra-ui/layout'
import React from 'react'
import { AccountDetails } from '../../types/AccountDetails'

interface AccountFeaturesProps extends BoxProps {
  accountDetails: AccountDetails
}

const AccountFeatures = ({ accountDetails, ...rest }: AccountFeaturesProps) => {
  const featureDetails = [
    {
      term: 'Master Account',
      value: accountDetails.isMaster,
    },
    {
      term: 'Check Writing',
      value: accountDetails.checkWritingIndicator,
    },
    {
      term: 'Debit Card',
      value: accountDetails.debitCardIndicator,
    },
    {
      term: 'ACH Profile on File',
      value: accountDetails.hasAchInfo,
    },
    {
      term: 'FDIC Sweep',
      value: accountDetails.hasFdicInfo,
    },
  ]

  return (
    <Section data-testid="account-features-table" {...rest}>
      <SectionHeader>Account Features</SectionHeader>
      <DefinitionList>
        {featureDetails.map(
          (feature, index) =>
            feature.value != null && (
              <Definition
                key={index}
                term={feature.term}
                definition={feature.value ? 'Yes' : 'No'}
              />
            )
        )}
      </DefinitionList>
    </Section>
  )
}

export default AccountFeatures
